import { render, staticRenderFns } from "./withdrawModal.vue?vue&type=template&id=6cf170fe&scoped=true"
import script from "./withdrawModal.vue?vue&type=script&lang=js"
export * from "./withdrawModal.vue?vue&type=script&lang=js"
import style0 from "./withdrawModal.vue?vue&type=style&index=0&id=6cf170fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf170fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf170fe')) {
      api.createRecord('6cf170fe', component.options)
    } else {
      api.reload('6cf170fe', component.options)
    }
    module.hot.accept("./withdrawModal.vue?vue&type=template&id=6cf170fe&scoped=true", function () {
      api.rerender('6cf170fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/withdrawModal.vue"
export default component.exports